import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import 'antd/dist/antd.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { LocalizationProvider } from './lib/localization';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider>
        <App />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
